import { render, staticRenderFns } from "./Busca.vue?vue&type=template&id=564216d8&scoped=true&"
import script from "./Busca.vue?vue&type=script&lang=js&"
export * from "./Busca.vue?vue&type=script&lang=js&"
import style0 from "./Busca.vue?vue&type=style&index=0&id=564216d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564216d8",
  null
  
)

export default component.exports